import React from 'react';

const paths = {
  menu: 'M4 7h16M4 12h16M4 17h16', search: 'M11 4a7 7 0 100 14 7 7 0 000-14zm5 12l4 4',
  trend: 'M4 17l6-6 4 4 6-8M15 7h5v5', users: 'M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zm11 10v-2a4 4 0 00-3-3.87',
  clock: 'M12 22a10 10 0 100-20 10 10 0 000 20zm0-15v5l3 2', check: 'M5 12l4 4L19 6', plus: 'M12 5v14M5 12h14',
  arrowRight: 'M5 12h14m-6-6l6 6-6 6', arrowLeft: 'M19 12H5m6-6l-6 6 6 6', pin: 'M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1116 0zm-8 3a3 3 0 100-6 3 3 0 000 6z',
  more: 'M5 12h.01M12 12h.01M19 12h.01', diamond: 'M12 3l9 9-9 9-9-9 9-9z', link: 'M10 13a5 5 0 007.54.54l2-2a5 5 0 00-7.07-7.07l-1.15 1.15M14 11a5 5 0 00-7.54-.54l-2 2a5 5 0 007.07 7.07l1.14-1.14',
  edit: 'M12 20h9M16.5 3.5a2.12 2.12 0 013 3L8 18l-4 1 1-4L16.5 3.5z',
  delete: 'M3 6h18M8 6V4h8v2M19 6l-1 15H6L5 6m4 4v7m6-7v7',
  upload: 'M12 16V4m0 0L7 9m5-5l5 5M5 20h14',
  download: 'M12 4v12m0 0l-5-5m5 5l5-5M5 20h14',
  file: 'M6 2h8l4 4v16H6zM14 2v5h5M9 13h6M9 17h6',
};

function Icon({ name, className = '' }) {
  return <svg className={`ui-icon ${className}`} viewBox="0 0 24 24" aria-hidden="true"><path d={paths[name]} /></svg>;
}

export default Icon;
